import { render, staticRenderFns } from "./HomeDigitalClinicsBanner.vue?vue&type=template&id=0faeb0a6"
import script from "./HomeDigitalClinicsBanner.vue?vue&type=script&lang=js"
export * from "./HomeDigitalClinicsBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeDigitalClinicsBanner.vue?vue&type=style&index=0&id=0faeb0a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports